export enum CustomFilterType {
    String,
    Number,
    Date,
    Collection,
    CollectionNumber,
    Boolean
}

export enum CustomFilterOperator {
    Equals,
    LessThan,
    GreaterThan,
    Contains,
    Or,
    NotEquals,
    GreaterThanOrEqual,
    LessThanOrEqual
}

export interface CustomFilterField {
    fieldName: string;
    viewName?: string;
    fieldType: CustomFilterType;
    operators: Array<CustomFilterOperator>;
    labelName?: string;
    sortOrder?: number;
    lutApiEndPoint?: string;
    lutKeyField?: string;
    lutDescField?: string;
    toolTip?: string;
    multiSelect?: Boolean;
}

export interface CustomFilter {
    field: CustomFilterField;
    operator: CustomFilterOperator;
    searchValue: string;
}

